import { AssetSortKey, DEFAULT_ASSET_SORT, ASSET_SORT_KEYS } from '@kagami/shared/assetSort'

// Custom MIME types used by the asset / folder drag-and-drop. They are used in
// dataTransfer payloads to distinguish drags initiated within the assets UI
// from external drags (file uploads, URLs, etc.).
export const ASSET_DRAG_MIME = 'application/kagami-asset-ids'
export const FOLDER_DRAG_MIME = 'application/kagami-folder-id'

// Per-mediaType marker (empty value) added alongside ASSET_DRAG_MIME so drop
// targets can grey-out / accept based on the dragged asset's media type during
// dragover (where dataTransfer values aren't readable, only types are).
// NOTE: prefix intentionally distinct from ASSET_DRAG_MIME so a `startsWith`
// check on `dataTransfer.types` doesn't accidentally pick up the ids type.
export const ASSET_MEDIA_PREFIX = 'application/kagami-asset-mediatype-'
export const assetMediaDragType = (mediaType: string) => `${ASSET_MEDIA_PREFIX}${mediaType}`

const ASSET_SORT_LABELS: Record<AssetSortKey, string> = {
    [AssetSortKey.Date]: 'Date',
    [AssetSortKey.Name]: 'Name',
}

export const ASSET_SORT_DROPDOWN_OPTIONS = ASSET_SORT_KEYS.map((value) => ({
    value,
    label: ASSET_SORT_LABELS[value],
}))

export { DEFAULT_ASSET_SORT }
